export default __webpack_public_path__ + "static/media/dl_flyer_portrait_99x210mm_.7b5d5da4.png";